import * as React from 'react';
import * as _ from 'lodash';
import { useCallback, useRef, useState } from 'react';
import TextFieldWrapper from '../../../../components/TextFieldWrapper/TextFieldWrapper';
import { ReactChildrenGeneralType } from '../../../../../models/ReactChildrenGeneralType';

type TransformFilterHeaderWrapperProps = {
    children?: ReactChildrenGeneralType,
    name: string,
    label: string,
    onChange: (name: string, value: string) => void;
}

export function TransformFilterHeaderWrapper({ children, name, label, onChange }: TransformFilterHeaderWrapperProps) {
    const [isFilterModeActive, setIsFilterModeActive] = useState(false);
    const [query, setQuery] = useState('');
    const isActiveRef = useRef(false);


    const updateSearch = _.debounce((newVal) => {
        if (isActiveRef.current) {
            onChange(name, newVal.toLowerCase());
        }
    }, 500);

    const handleClose = () => {
        isActiveRef.current = false;
        setIsFilterModeActive(false);
        setQuery('');
        onChange(name, '');
    };


    const handleChange = (e) => {
        const newVal = e.target.value;
        setQuery(newVal);
        updateSearch(newVal);
    };

    return <div className="transform-filter-header-wrapper">

        {!isFilterModeActive ? <>
            <div className="transform-filter-header-wrapper__label">
                <i className="icon icon-alan-search" onClick={() => {
                    isActiveRef.current = true;
                    setIsFilterModeActive(prev => !prev);
                }} />
                <div>{label}</div>
            </div>
            {children}
        </> : <>
            <TextFieldWrapper
                name="query"
                id="query"
                className="transform-filter-header-wrapper__input-wrapper"
                placeholder="Search"
                value={query}
                autoComplete="off"
                autoFocus={true}
                shouldBlurBeFired={true}
                onChange={handleChange}
                onBlur={handleClose}
                onEsc={handleClose}
                skipOnChangeAfterOnBlur={true}
                height={32}
            />
            <i className="icon icon-alan-close-rounded" onClick={handleClose} />
        </>}
    </div>;
}